import React, { useState } from 'react';
import PageShell from './PageShell';
import { submitSupportTicket } from '../api/supportTickets';

const fieldStyle = { padding: '10px', margin: '5px 0', borderRadius: '5px', border: '1px solid #ddd', width: '100%' };

const ContactSupportPage = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    setSuccess(null);

    if (!name || !email || !message) {
      setError('Please fill in all fields.');
      setIsSubmitting(false);
      return;
    }

    const isValidEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!isValidEmail.test(email)) {
      setError('Please enter a valid email address.');
      setIsSubmitting(false);
      return;
    }

    try {
      await submitSupportTicket({ name, email, message });
      setSuccess('Your message has been sent. We will get back to you shortly!');
      setName('');
      setEmail('');
      setMessage('');
    } catch (err) {
      setError(err.message || 'There was an error sending your message. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PageShell title="Contact support" subtitle="Reach the false alarm permit program team.">
      {error && (
        <p className="rhs-error" role="alert">
          {error}
        </p>
      )}
      {success && <p className="rhs-ok-text">{success}</p>}

      <form onSubmit={handleSubmit} className="rhs-form-block">
        <div style={{ marginBottom: '10px' }}>
          <label htmlFor="name">Name</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            style={fieldStyle}
          />
        </div>

        <div style={{ marginBottom: '10px' }}>
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={fieldStyle}
          />
        </div>

        <div style={{ marginBottom: '10px' }}>
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
            rows={4}
            style={fieldStyle}
          />
        </div>

        <div>
          <button type="submit" className="rhs-btn" disabled={isSubmitting}>
            {isSubmitting ? 'Sending...' : 'Send message'}
          </button>
        </div>
      </form>
    </PageShell>
  );
};

export default ContactSupportPage;
